import { ACTION } from "@/lib/auth/actions";
import { hasPermission } from "@/lib/authv2/permissions";
import type { Staff } from "@/lib/authv2/store";

/**
 * Ai mở được màn "Vận hành in" (gói I màn 9): đúng quyền máy chủ gác cửa báo
 * cáo — print.ops.report (quản trị, giám đốc, trưởng cửa hàng). Máy chủ còn cắt
 * theo phạm vi cơ sở và che tiền với vai không xem được tiền đơn.
 */
export function canReadPrintOpsReport(staff: Staff | null | undefined): boolean {
  if (!staff) return false;
  return hasPermission(ACTION.PrintOpsReport);
}
